import React from 'react';
import PropTypes from 'prop-types';

/**
 * A Timer button component that executes a function after a timeout.
 * Uses CSS transition for visual feedback of the timer to see how much time left before function executes.
 * Can be used in the background with the 'hidden' prop.
 */
class TimerButton extends React.Component {
  static defaultProps = {
    /** milliseconds */
    interval: 5000,
    /** Function that executes after the interval time */
    onTick: () => {},
    /** Hides the timer */
    hidden: false,
    transitionProperty: 'background-position',
    onToggle: () => {},
    /** Running override */
    paused: false,
  };

  static propTypes = {
    interval: PropTypes.number,
    onTick: PropTypes.func,
    hidden: PropTypes.bool,
    transitionProperty: PropTypes.string,
    onToggle: PropTypes.func,
    paused: PropTypes.bool,
  };

  state = {
    running: false,
  };

  timer = null;

  stop() {
    this.clearTimeouts();

    this.setState({ running: false });
  }

  restart() {
    /**
     * CSS transitions need the dom element to be mounted at all times during the transition
     * This component achieves CSS animation by resetting transition-duration to 0ms and reverses the transition-property (background-position).
     * This "animates" the back to the original position with no delay.
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Transitions/Using_CSS_transitions#JavaScript_examples
     */

    const { onTick, interval } = this.props;
    this.clearTimeouts();

    this.setState({ running: false });
    this.timer = setTimeout(() => {
      onTick();
    }, interval);
    this.timerRestart = setTimeout(() => {
      this.setState({ running: true });
    }, 100);
  }

  clearTimeouts() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.timerRestart) {
      clearTimeout(this.timerRestart);
    }
  }

  componentWillUnmount() {
    this.clearTimeouts();
  }

  componentDidUpdate() {
    if (this.props.paused && this.state.running) {
      this.stop();
    }
  }

  render() {
    const {
      label,
      interval,
      hidden,
      onToggle,
      transitionProperty,
      className = '',
      style = {},
    } = this.props;
    const { running } = this.state;

    const transitionDuration = running ? interval : 0;
    const backgroundPosition = running ? 'left bottom' : 'right bottom';
    const animationStyle = {
      transition: `${transitionProperty} ${transitionDuration}ms linear`,
      backgroundPosition,
    };
    const timerContainerStyles = { opacity: hidden ? 0 : 1, ...style };
    return (
      <div className={className} style={timerContainerStyles}>
        <button style={animationStyle} onClick={onToggle}>
          {label}
        </button>
      </div>
    );
  }
}

export default TimerButton;



// WEBPACK FOOTER //
// ./src/common/Components/TimerButton/index.js